var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"airST-conditional-card"},'div',_vm.$attrs,false),[(_vm.title)?_c('div',{staticClass:"airST-conditional-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"airST-conditional-contents"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }